<template>
  <div id="index-h5">
    <head-Back title="登录/注册" url="/index"></head-Back>
    <div id="login" class="login">
      <div class="logo">
        <img src="../../assets/img/logo-hyb.png" />
        <br />
        <span>好运吧</span>
      </div>

      <div class="login-div">
        <input
          type="text"
          name="mobile"
          oninput="if(value.length>11)value=value.slice(0,11)"
          v-model="from.mobile"
          class="login-input"
          placeholder="请输入手机号"
          @keyup="setLoginData"
          @keydown="handleinput2"
        />
      </div>
      <div class="login-input-mar">
        <input
          type="text"
          name="password"
          oninput="if(value.length>5)value=value.slice(0,5)"
          v-model="from.code"
          class="login-input"
          placeholder="请输入验证码"
          @keyup="setLoginData"
          @keydown="handleinput2"
        />
        <button id="sendCode" :disabled="btnDisabled" @click="opentTan">{{ btnText }}</button>
      </div>
      <div>
        <div class="agree-img" @click="changeImg" @keyup="setLoginData">
          <img :src="imgFlag == false ? unimgSrc : imgSrc" alt />
        </div>

        <div class="agree-text">
          我已阅读并且同意
          <a @click="goRegistAgree">《注册协议》</a>
          <a @click="goPrivacyAgree">《隐私协议》</a>
        </div>
      </div>
      <div class="login-button">
        <button @click="loginCode">立即登录</button>
      </div>
    </div>

    <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-head">
        <img :src="closeSrc" @click="closeTan" />
      </div>
      <div class="tan-page">
        <div class="tan-page-text">请输入图形验证码</div>
        <div class="tan-page-code">
          <div class="tan-page-code-img" @click="getCode">
            <img :src="codeimg" alt />
          </div>
          <div class="tan-page-code-input">
            <input
              type="text"
              v-model="tuicode"
              oninput="if(value.length>4)value=value.slice(0,4)"
              placeholder="请输入验证码"
              @keydown="handleinput2"
            />
          </div>
        </div>
      </div>
      <div class="tan-foot" @click="sendCode">
        <span>确认</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "登录/注册"
  },
  name: "login",
  data() {
    return {
      msg: "登录/注册",
      imgFlag: false,
      unimgSrc: require("../../assets/img/disagree@2x.png"),
      imgSrc: require("../../assets/img/agree.png"),
      closeSrc: require("../../assets/img/close@2x.png"),
      codeshow: true,
      codeimg: "",
      from: {
        mobile: "",
        code: "",
        shareType: 1,
        shareId: null
      },
      tuicode: "",
      btnText: "发送验证码",
      btnDisabled: false,
      checkbox: ""
    };
  },
  mounted: function() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    console.log(
      "store里面的getUserInfo有值" + JSON.stringify(this.getUserInfo)
    );

    if (token == "" || token == null) {
      this.from.mobile = "";
      this.from.code = "";
      this.imgFlag = false;
    } else {
      //this.$router.push("/index");
    }

    var loginObje = this.getLoginObj;
    console.log("loginObje :" + JSON.stringify(loginObje));
    if (loginObje != null && loginObje != undefined) {
      this.from.mobile = loginObje.mobile;
      //this.from.code = loginObje.code;
      this.imgFlag = false;
    }


    var type = this.$route.params.shareType;
    var shareid = this.$route.params.shareId;
    console.log("type:" + type + "  shareid" + shareid);
    this.from.shareType = type;
    this.from.shareId = shareid;

    //获取渠道id
    var cid = this.$cookies.get('hyb_cid');
    console.log("channel id is ："+cid)
    //用户打开首页链接后，用户访问的渠道将设置为官网
    if(cid != null && cid != undefined && cid != ""){
      store.commit(types.SET_CHANNEL, cid);
       this.$cookies.remove('hyb_cid') 
    }


  },
  methods: {
    handleinput2(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
      console.log(e.target.value.replace(/[^\d]/g, ""));
    },
    setLoginData() {
      var loginData = {
        mobile: this.from.mobile,
        code: this.from.code,
        imgFlag: this.imgFlag
      };
      if (util.isNum(this.from.mobile)) {
        store.commit(types.SET_LOGIN_OBJ, loginData);
      }
      if (util.isNum(this.from.code)) {
        store.commit(types.SET_LOGIN_OBJ, loginData);
      }
    },
    getCode: function() {
      let This = this;

      this.$axiosHttp({
        method: "POST",
        url: api.qml.getCode,
        data: this.from
      })
        .then(res => {
          //console.log("获取图形验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            this.codeimg = res.result;
            this.codeshow = false;
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    },
    sendCode: function() {
      var code = this.tuicode;
      if (code == null || code == "") {
        tips.toast("请输入验证码");
        return false;
      }

      var data = {
        mobile: this.from.mobile,
        type: 1,
        code: code
      };
      let This = this;

      this.$axiosHttp({
        method: "POST",
        url: api.qml.sendCode,
        data: data
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            tips.toast("发送成功");
            this.codeshow = true;
            this.getSecond(60);
            this.$point.eventId("btn_100002");
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    },
    loginCode: function() {
      this.$point.eventId("btn_100003");

      var mobile = this.from.mobile;
      if (mobile == null || mobile == "") {
        tips.toast("请输入手机号码");
        this.$point.eventId("btn_100006");

        return false;
      }
      if (!util.isPhone(this.from.mobile)) {
        tips.toast("请填写正确的手机号!");
        this.$point.eventId("btn_100006");

        return false;
      }
      var code = this.from.code;
      if (code == null || code == "") {
        tips.toast("请输入验证码");
        this.$point.eventId("btn_100006");

        return false;
      }
      if (this.imgFlag == false) {
        tips.toast("请勾选协议");
        this.$point.eventId("btn_100006");

        return false;
      }

      this.$axiosHttp({
        method: "POST",
        url: api.qml.login,
        data: this.from
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            //console.log(JSON.stringify( res.result));
            console.log(JSON.stringify(res.result.userRelList[0].code));
            //将对应的数据保存到Vuex中
            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_TOKEN_SCOKET, res.result.socketToken);

            store.commit(types.SET_USERLIST, res.result.userRelList);
            store.commit(types.LOGIN, res.result.usertoken);

            store.commit(types.SET_CODE, res.result.userRelList[0].code);
            //用户打开首页链接后，用户访问的渠道将设置为官网
            // store.commit(types.SET_CHANNEL, res.result.channelid);
            // console.log(
            //   "store里面的getChannel有值" + JSON.stringify(this.getChannel)
            // );
            localStorage.setItem("token", res.result.usertoken);

            //登录成功
            tips.toast("登录成功");
            // this.$router.push("userCenters");
            this.$router.push("/downapp");
            
            this.$point.eventId("btn_100004");
          } else {
            tips.toast(res.message);
            this.$point.eventId("btn_100005");
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
          this.$point.eventId("btn_100005");
        });
    },
    changeImg: function() {
      if (this.imgFlag == true) {
        this.imgFlag = false;
      } else {
        this.imgFlag = true;
      }
    },
    goRegistAgree: function() {
      this.$router.push("/agree/register");
    },
    goPrivacyAgree: function() {
      this.$router.push("/agree/privacyAgree");
    },
    closeTan: function() {
      this.codeshow = true;
    },
    opentTan: function() {
      var mobile = this.from.mobile;
      if (mobile == null || mobile == "") {
        tips.toast("请输入手机号码");
        return false;
      }
      if (!util.isPhone(this.from.mobile)) {
        tips.toast("请填写正确的手机号!");
        return false;
      }
      // var code = this.from.code;
      // if(code == null || code == ''){
      //     tips.toast('请输入验证码');
      //     return false
      // }
      var flag = this.getCode();
      console.log("获取" + flag);
      this.$point.eventId("btn_100001");
    },
    //发送验证码
    getSecond(wait) {
      let _this = this;
      let _wait = wait;
      if (wait == 0) {
        this.btnDisabled = false;
        this.btnText = "重新获取";
        wait = _wait;
      } else {
        this.btnDisabled = true;
        this.btnText = "" + wait + "s";
        wait--;
        setTimeout(function() {
          _this.getSecond(wait);
        }, 1000);
      }
    }
  },
  components: {
    headBack
  },
  watch: {
    from: {
      handler(val, oldVal) {
        console.log("from: " + JSON.stringify(val));
        val.mobile = val.mobile.replace(/[^\d]/g, "");
        val.code = val.code.replace(/[^\d]/g, "");
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          val.code = val.code.substring(0, 5);
        } else {
        }
      },
      deep: true //true 深度监听
    },
    tuicode: {
      handler(val, oldVal) {
        console.log("tuicode: " + JSON.stringify(val));
        this.tuicode = val.replace(/[^\d]/g, "");
      },
      deep: true //true 深度监听
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getLoginObj"
    ])
  }
};
</script>
<style scoped>
#index-h5 {
  width: 750px;
  height: auto;
  min-height: 100%;
  background: url("../../assets/img/login-bj@2x.png");
  overflow: hidden;
  background-size: 100% 100%;
}
.login {
  width: 750px;
  height: 1334px;
}
.logo {
  width: 192px;
  height: 188px;
  padding: 70px 278px 0px 280px;
}

.logo img {
  width: 144px;
  height: 144px;
}

.logo span {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 74px;
}

.login-div {
  margin-top: 82px;
}

.login-input {
  width: 632px;
  height: 46px;
  background: rgba(19, 19, 37, 1);
  border: 1px solid rgba(19, 19, 37, 1);
  border-radius: 16px;
  color: #ffffff;
  padding: 30px 20px 20px 22px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
}
.login-input input::-webkit-input-placeholder {
  width: 100%;
  height: 40px;
  background: rgba(19, 19, 37, 1);
  border-radius: 16px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(135, 134, 144, 1);
  line-height: 40px;
  position: relative;
  left: 20px;
}
.login-input-mar {
  margin: 34px 0px 16px 0px;
}

.agree-img {
  width: 28px;
  height: 28px;
  border-radius: 16px;
  margin: 3px 28px 0px 108px;
  position: relative;
  float: left;
}
.agree-img img {
  width: 28px;
  height: 28px;
  position: absolute;
}

.agree-text {
  width: 580px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(122, 124, 135, 1);
  line-height: 34px;
  position: relative;
  float: left;
  text-align: left;
}

.agree-text a {
  color: #958ee2;
}

#sendCode {
  display: block;
  position: absolute;
  width: 200px;
  height: 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(157, 152, 255, 1);
  line-height: 40px;
  float: right;
  margin: -88px 0px 0px 500px;
  border: none;
  background: #131325;
  text-align: right;
}

.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width: 540px;
  height: 370px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99999;
}

.tan-back {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 50px;
}
.tan-head img {
  position: relative;
  width: 32px;
  height: 32px;
  float: right;
  margin: 16px 20px 0 0;
}
.tan-page {
  width: 100%;
  height: 240px;
}
.tan-foot {
  width: 540px;
  height: 102px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(56, 48, 234, 1) 100%
  );
  border-radius: 0px 0px 16px 16px;
}

.tan-foot span {
  width: 240px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 100px;
}

.tan-page-text {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 38px;
  padding: 20px 0 0 0;
}
.tan-page-code {
  width: 476px;
  height: 100px;
  padding: 30px 0 0 32px;
}
.tan-page-code div {
  float: left;
}

.tan-page-code-img {
  width: 190px;
  height: 92px;
  border-radius: 61px;
}

.tan-page-code-img img {
  width: 190px;
  height: 92px;
}

.tan-page-code-input {
  width: 272px;
  height: 92px;
  margin: 0 0 0 14px;
}
.tan-page-code-input input {
  width: 202px;
  height: 61px;
  background: rgba(247, 247, 247, 1);
  border-radius: 61px;
  border: none;
  padding: 15px 35px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  text-align: center;
}

.tan-page-code-input input::-webkit-input-placeholder {
  position: relative;
  left: 20px;
  width: 172px;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  margin-left: -10px;
}
.login-button {
  width: 632px;
  height: 92px;
  margin: 94px auto 0;
}

.login-button button {
  width: 632px;
  height: 92px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 50px;
  border: none;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
}

.login-button button:active {
  background: rgba(175, 199, 255, 1);
}

.tanhide {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/login.vue